module.exports = __webpack_public_path__ + "static/media/cardpay.9485fd68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cardpay.png
// module id = 1123
// module chunks = 0